const replayLogoImage = {
  src: '/incoming/21348968-v0-replay-logo.png',
  alt: 'Replay logo',
  width: 60,
  height: 26,
  crops: {},
} as const

const expectedDimensions = { width: 60, height: 26 } as const

const constraints = {
  desktop: expectedDimensions,
  tablet: expectedDimensions,
  mobile: expectedDimensions,
  mobileSmall: expectedDimensions,
} as const

export { replayLogoImage, expectedDimensions, constraints }
